import i18n from "@/i18n.js";
export default [
  {
    applySearchButton: false,
    default: null,
    description: i18n.t("add-section-form.create-section-label"),
    id: "sectionType",
    mandatory: true,
    name: i18n.t("add-section-form.create-section-label"),
    options: [
      {
        name: "templateSection",
        label: i18n.t("add-section-form.template-section") ,
        value: "text"
      },
      {
        name: "aISection",
        label: i18n.t("add-section-form.ai-section"),
        value: "ai"
      }
    ],
    placeholder: i18n.t("add-section-form.section-type"),
    readonly: false,
    secret: false,
    showIfTrue: null,
    type: "Radio"
  },
  {
    applySearchButton: false,
    default: "",
    description: i18n.t("add-section-form.section-name"),
    id: "sectionName",
    mandatory: true,
    name: i18n.t("add-section-form.section-name"),
    options: null,
    placeholder: i18n.t("add-section-form.name-placeholder"),
    readonly: false,
    secret: false,
    showIfTrue: null,
    type: "Text",
    focus: true
  }
];
